import React, { useState } from 'react';
import { useSelector } from 'react-redux';

import AccordionItem from '../../../../components/Accordion/AccordionItem';
import {
  selectCurrentBodyTemplateName,
  selectDefaultTemplate
} from '../../../../redux/modules/emails';
import EmailBody from '../EmailComponents/EmailBody';

import './styles.scss';

function EmailContentDropdown() {
  const currentBodyTemplateName = useSelector(selectCurrentBodyTemplateName);
  const defaultTemplate = useSelector(selectDefaultTemplate);
  const [isOpen, toggleIsOpen] = useState(true);

  const { templateName = '' } = defaultTemplate;

  return (
    <AccordionItem
      isOpen={isOpen}
      title={`CONTENT: (${currentBodyTemplateName || templateName})`}
      toggle={toggleIsOpen}
    >
      <EmailBody
        backgroundColor="greyScale.100"
        bodyContainerId="email-body-editor"
        selectCodeType="modal"
        subjectContainerId="subject-editor"
      />
    </AccordionItem>
  );
}

export default EmailContentDropdown;
